import css from 'styled-jsx/css';

const AvailabilityLocationStyles = css`
  .delivery-option-location {
    .delivery-location-text {
      color: #333;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      leading-trim: NONE;
      letter-spacing: 0%;
      vertical-align: middle;
    }
    .delivery-location-text__span {
      text-decoration: underline;
    }
  }
`;

export { AvailabilityLocationStyles };
